import Cookies from 'js-cookie'

import { SHOPIFY_CART_ID_COOKIE } from '@lib/constants'

const getCartId = () => Cookies.get(SHOPIFY_CART_ID_COOKIE)

export default getCartId
